import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { APPMODE } from './main.js'

const root = ReactDOM.createRoot(document.getElementById('root'))
if (APPMODE == 'prod') {
  root.render(
    <App />
  )
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}